import React from "react";
import { useCall, useConnectedUser, VideoPreview } from "@stream-io/video-react-sdk";
import defaultAvatar from "../../assests/defaultProfileImage.png";
import { useSelector } from "react-redux";
import { FaVideo, FaVideoSlash } from "react-icons/fa6";


const SwitchLayout = ({ request, updatePermission, members, participant }) => {
    const { userData } = useSelector((state) => state.user);
    const call = useCall();
    const connectedUser = useConnectedUser();
    const membersToShow = (members || []).map(({ user }) => user).filter((user) => user.id !== connectedUser.id) || [];
    const { name, image } = membersToShow[0] ?? {}


    const handleSwitch = async () => {
        await call.update({ custom: { type: 'video' } })
        await call.grantPermissions(request?.user.id, request?.permissions);
        updatePermission(null)
    }

    const handleDecline = async () => {
        await call.grantPermissions(request.user.id, request.permissions)
        updatePermission(null)
    }

    const isMyRequest = request?.user.id === userData?.userId;

    return (
        <div className="flex flex-col aspect-[4/3] bg-gray-600 justify-center items-center relative rounded-md">
            <div className="absolute top-0 left-0 bg-black/70 z-20 p-4 flex gap-2 items-center">
                <img
                    className="w-16 h-16 rounded-full border-full border-customGold shadow-md" src={image || participant?.image || defaultAvatar} alt="User Profile"
                />
                <div>
                    <p className="text-white text-xl font-semibold">{name || participant?.name}</p>
                    <div className="flex gap-2 items-center">
                        <p className="text-white text-sm ">Requesting Video Call</p>
                        <FaVideo className="text-sm animate-wiggle" />
                    </div>
                </div>
            </div>

            <VideoPreview />

            {!isMyRequest &&
                <div className="absolute bottom-4 flex items-center justify-between w-full px-3">
                    <button
                        onClick={handleSwitch}
                        className="mt-4 px-4 py-2 flex flex-col items-center bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition"
                    >
                        Switch to Video 
                        <FaVideo className="text-xl animate-wiggle" />
                    </button>

                    <button
                        onClick={handleDecline}
                        className="mt-4 px-4 py-2 flex flex-col items-center bg-red-500 hover:bg-red-600 text-white rounded-lg transition"
                    >
                        Decline Switch
                        <FaVideoSlash className="text-sm animate-wiggle" />
                    </button>
                </div>
            }

            {isMyRequest &&
                <div className="absolute flex items-center bottom-4 rounded-full bg-gray-800 px-5 p-2 gap-1 font-sans font-semibold">
                    <p className="text-sm">awaiting request...</p>
                    <FaVideo className="text-sm inline-block animate-wiggle" />
                </div>
            }
        </div>
    )
}


export default SwitchLayout